import React from 'react';
import './PageContent.css';

import { Grid } from '@mui/material';

import approvalIcon from '../Images/Icons/approvals-form-icon.png';
import loansIcon from '../Images/Icons/loans-form-icon.png';
import creditIcon from '../Images/Icons/credit-form-icon.png';
import obligationIcon from '../Images/Icons/obligation-form-icon.png';
import optionsIcon from '../Images/Icons/options-form-icon.png';
import evolveIcon from '../Images/Icons/evolve-form-icon.png';
import googleIcon from '../Images/Icons/google_g_icon_download.png';

const PageContent = ({formData}) => {
    const moveToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
    return (
        <div className='page-content-div'>
            <div className='google-div'>
                <div className='google-section-card'>
                    <table>
                        <tbody>
                            <tr>
                                <td rowSpan={2}>
                                    <img className='page-content-table-image' src={googleIcon} height={50} alt="google logo" />
                                </td>
                                <td>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td colSpan={2}>{formData.lang === "fr" ? "Note Google" : "Google Rating"}</td>
                                            </tr>
                                            <tr>
                                                <td><span className='google-rating-text'>4.9</span></td>
                                                <td><span className='google-rating-text'>★★★★★</span></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className='page-content-section'>
                <div className='page-content-header'>
                    {formData.lang === "fr" ? "Estimation de prêt personnelle" : "Start the Process"}
                    <div className='page-content-sub-header'>{formData.lang === "fr" ? "en 3 étapes simples" : "Apply in 3 Simple Steps"}</div>
                </div>
                <div className='page-content-card'>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <span className='page-content-table-header'>1.</span>
                                </td>
                                <td>
                                    <span className='page-content-table-header'>{formData.lang === "fr" ? "Remplissez le formulaire" : "Kickstart Your Application"}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    &nbsp;
                                </td>
                                <td>
                                    <span className='page-content-text'>{formData.lang === "fr" ? "Bénéficiez d’un processus de candidature rapide, simple et sécurisé. Obtenez votre approbation aujourd'hui." : "Dive into a quick, easy, and safe application process. You could be approved and funded today!"}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <span className='page-content-table-header'>2.</span>
                                </td>
                                <td>
                                    <span className='page-content-table-header'>{formData.lang === "fr" ? "Découvrez votre offre parfaite" : "Discover Your Perfect Offer"}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    &nbsp;
                                </td>
                                <td>
                                    <span className='page-content-text'>{formData.lang === "fr" ? "Connectez-vous avec un prêteur et finalisez une offre adaptée à vos besoins." : "Connect with a lender, finalize an offer tailored to you, and set up terms that fit your plan."}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <span className='page-content-table-header'>3.</span>
                                </td>
                                <td>
                                    <span className='page-content-table-header'>{formData.lang === "fr" ? "Recevez l’argent" : "Get Your Money"}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    &nbsp;
                                </td>
                                <td>
                                    <span className='page-content-text'>{formData.lang === "fr" ? "L’argent atterrit directement dans votre compte et grâce aux déductions automatisées, les remboursements seront très pratiques." : "Money lands directly in your account, and with automated deductions, repayments are a breeze."}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button className='start-button' onClick={moveToTop}>{formData.lang === "fr" ? "Appliquer maintenant" : "Apply Now"}</button>
                </div>
            </div>

            <div className='page-content-section'>
                <div className='page-content-header'>{formData.lang === "fr" ? "Pourquoi choisir Loans Canada?" : "Why Choose Loans Canada?"}</div>
                <div className='page-content-card'>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={approvalIcon} height={60} alt="approval icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-red-title'>{formData.lang === "fr" ? "Évaluations rapides" : "Rapid Approvals"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Accélérez votre processus de demande de prêt grâce aux approbations rapides" : "Fast-track your loan application process with swift approvals"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={loansIcon} height={60} alt="loans icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-green-title'>{formData.lang === "fr" ? "Prêts jusqu'à 50 000 $" : "Loans up to $50,000"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Obtenez des prêts allant jusqu'à 50 000 $ pour vos besoins financiers" : "Secure loans of up to $50,000 to meet your financial needs"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={obligationIcon} height={60} alt="obligation icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-blue-title'>{formData.lang === "fr" ? "100% gratuit sans obligation" : "100% Free with No Obligation"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Une demande de prêt avec Loans Canada est absolument gratuit et sans aucune obligation" : "Applying for a loan with Loans Canada is absolutely free, and there's no obligation attached"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={creditIcon} height={60} alt="credit icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-red-title'>{formData.lang === "fr" ? "Rétablissement de crédit" : "Credit Rebuilding"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Profitez-en pour rebâtir votre crédit tout en obtenant le financement dont vous avez besoin" : "Take the opportunity to rebuild your credit while obtaining the financing you require"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={optionsIcon} height={60} alt="options icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-green-title'>{formData.lang === "fr" ? "Une application, nombreuses options" : "Single Application, Multiple Options"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Soumettez une seule demande et recevez plusieurs options de prêt parmi lesquelles choisir" : "Submit one application and receive multiple loan options to choose from"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <div style={{ borderTop: '1px solid #CFCFCF', marginTop: 10, marginBottom: 10 }}></div>
                    <Grid container flexDirection={'row'} spacing={1}>
                        <Grid item xs={2.5}>
                            <img className='page-content-table-image' src={evolveIcon} height={60} alt="evolve icon" />
                        </Grid>
                        <Grid item xs={9.5}>
                            <div className='page-content-table-row'>
                                <div className='page-content-table-header special-blue-title'>{formData.lang === "fr" ? "Grandissez avec nous" : "Evolve with Us"}</div>
                                <div className='page-content-text'>{formData.lang === "fr" ? "Prospérez avec le soutien d'Insurdinary et de notre suite de produits d'assurance et financiers" : "Grow and prosper with the support of Insurdinary and our suite of insurance and financial products"}</div>
                            </div>
                        </Grid>
                    </Grid>
                    <button className='start-button' onClick={moveToTop}>{formData.lang === "fr" ? "Obtenez votre prêt" : "Get Your Loan Now"}</button>
                </div>
            </div>


        </div>
    )
}

export default PageContent;